import React from "react";
import Period from "./Period";

export default () => {
  return <Period />;
};
